/**
 * feature/manager — spec §F9 (Data Manager).
 * PLACEHOLDER: this feature ships in milestone M6 (§K). M1 Task 7 creates the folder per
 * the §B5 tree and a component that renders the milestone marker, so every route in §F1
 * resolves and the topbar nav is exercised end to end from M1. Strings go through
 * `t()` per §F12 (keys under `placeholder.`).
 */
import { useTranslation } from 'react-i18next';

import { Placeholder } from '../../components/Placeholder';

export function ManagerPage() {
  const { t } = useTranslation();
  return (
    <Placeholder
      title={t('placeholder.manager')}
      body={t('placeholder.managerBody')}
      milestone="M6"
    />
  );
}

export default ManagerPage;
